import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import Login from "./pages/Login/Login";
import Client from "./pages/Client/Client";
import Nurse from "./pages/Nurse/Nurse";
import EMRRegister from "./pages/Client/Popup/EMRRegister";
import NotFound from "./pages/Error/NotFound";
import DashBoard from "./components/Dashboard/DashBoard";
import useAxiosSetup from "../src/hooks/useAxiosSetup";
import { setupAxios } from "./utils/axiosConfig";
import AdminCommunity from "./pages/Client/Menu/Bbs/AdminCommunity";

function App() {
  // Axios 기본 설정 초기화
  useEffect(() => {
    setupAxios();
  }, []);

  // 초기화 시 "Patient" 권한이면 로그아웃 처리
  useEffect(() => {
    const auth = localStorage.getItem("auth");
    if (auth === "Patient" && auth !== null) {
      handleLogout();
    }
  }, []);

  const initialIsLoggedIn = localStorage.getItem("token") ? true : false;
  const initialIsAdmin = localStorage.getItem("auth") === "Superadmin" || localStorage.getItem("auth") === "Admin" ? true : false;
  const initialIsDoctor = localStorage.getItem("auth") === "Doctor" ? true : false;
  useAxiosSetup();

  const [isLoggedIn, setIsLoggedIn] = useState(initialIsLoggedIn);
  const [isAdmin, setIsAdmin] = useState(initialIsAdmin);
  const [isDoctor, setIsDoctor] = useState(initialIsDoctor);

  // auth가 "Admin"인지 확인하는 함수
  const checkIsAdmin = () => {
    return localStorage.getItem("auth") === "Superadmin" || localStorage.getItem("auth") === "Admin";
  };

  const checkIsDoctor = () => {
    return localStorage.getItem("auth") === "Doctor";
  };

  // 로그인 함수
  const handleLogin = () => {
    const token = localStorage.getItem("token");
    if (token) {
      setIsLoggedIn(true);
      setIsAdmin(checkIsAdmin());
      setIsDoctor(checkIsDoctor());
    }
  };

  // 로그아웃 함수
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("auth");
    localStorage.removeItem("userid");
    localStorage.removeItem("active");
    localStorage.removeItem("id");
    window.location.reload();
  };

  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/login" element={isLoggedIn ? <Navigate to="/" /> : <Login onLogin={handleLogin} />} />

          <Route path="/" element={isLoggedIn ? isAdmin ? <Navigate to="/admin" /> : isDoctor ? <Client /> : <Nurse /> : <Navigate to="/login" />} />

          {/* auth가 "Admin"인 경우에만 접근 가능 */}
          <Route path="/admin/*" element={isAdmin ? <DashBoard /> : <Navigate to="/" />} />
          {/* <Route exact path="/admin/qna" element={isAdmin ? <AdminCommunity /> : <Navigate to="/" />} />
          <Route exact path="/admin/qna/detail" element={isAdmin ? <AdminCommunity /> : <Navigate to="/" />} /> */}

          <Route path="/logout" element={<LogoutHandler onLogout={handleLogout} />} />

          <Route path="/EMRRegister" Component={EMRRegister} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </div>
  );
}

// LogoutHandler 컴포넌트 정의
function LogoutHandler({ onLogout }) {
  useEffect(() => {
    if (onLogout) {
      onLogout();
    }
    // 페이지를 /login으로 리다이렉트
    window.location.href = "/login";
  }, [onLogout]);

  return null; // 렌더링 할 내용이 없으므로 null 반환
}

export default App;
